export const LogoMark = ({ size = 36 }) => (
  <img
    src="/medallion.png"
    alt="Hustler's Hall"
    width={size}
    height={size}
    className="rounded-full select-none shrink-0"
    draggable={false}
  />
);

export const Logo = ({ size = 36 }) => <LogoMark size={size} />;
